import './styles.scss'

import { useCallback } from 'react'
import { Col, Empty, Row } from 'antd'

import { useAppDispatch } from '@/store/hook'
import { addProductToCart } from '@/store/slices/cartSlice'
import { sendProductDetail, showAddProductToWishlistModal } from '@/store/slices/wishlistSlice'
import { isValidArray } from '@/libs/utils/array'

import usePermission from '../../hooks/usePermission'
import { MODULE_SHOP_NAVIGATION_RIGHTS } from '../../libs/constants/modulerights'
import AddToCartButton from '../AddToCartBtn'
import ProductCard from '../ProductCard'

const MatchingProductsWithPaging = ({ products }) => {
  const dispatch = useAppDispatch()
  const { hasPermission: hasViewListPricePermission } = usePermission(
    MODULE_SHOP_NAVIGATION_RIGHTS.VIEW_LIST_PRICE,
  )

  const onAddProductToCart = useCallback(
    (materialId) => {
      dispatch(addProductToCart({ materialNumber: materialId }))
    },
    [dispatch],
  )

  const handleAddToWishlist = ({ materialName, materialNumber, img }) => {
    dispatch(sendProductDetail({ materialName, materialNumber, img }))
    dispatch(showAddProductToWishlistModal())
  }

  return (
    <Row
      style={{ marginBottom: 20 }}
      gutter={[
        { xs: 0, sm: 0, md: 24, lg: 32, xl: 32, xxl: 32 },
        { xs: 16, sm: 16, md: 24, lg: 32, xl: 32, xxl: 32 },
      ]}
    >
      {isValidArray(products)
        ? (
          products.map((item) => {
            return (
              <Col
                key={item.materialId}
                className="card-item"
                lg={8}
                md={12}
                sm={24}
                xl={6}
                xs={24}
              >
                <ProductCard
                  {...item}
                  isSuitableProduct
                  currencyUnit={item?.currencyUnit || item?.currency}
                  listPrice={item?.listPrice || item?.price}
                  requiresInstruction={item?.requiresInstruction}
                  addToCartBtn={
                    <AddToCartButton
                      handleClick={() => onAddProductToCart(item.materialId)}
                    />
                  }
                  shouldDisplayListPrice={item?.displayListPrice && hasViewListPricePermission}
                  onAddToWishlist={handleAddToWishlist}
                />
              </Col>
            )
          })
        )
        : (
          <div style={{ textAlign: 'center', width: '100%' }}>
            <Empty />
          </div>
        )}
    </Row>
  )
}

export default MatchingProductsWithPaging
